import { useEffect, useState } from "react";


const RoutePolyline: React.FC<google.maps.PolylineOptions> = (options: google.maps.PolylineOptions) => {
    
    const [polyline, setPolyline] = useState<google.maps.Polyline>();

    useEffect(() => {
        if (!polyline) {
            setPolyline(new google.maps.Polyline());
        }
        return () => {
            if (polyline) {
                polyline.setMap(null);
            }
        }
    }, [polyline]);

    useEffect(() => {
        if (polyline) {
            polyline.setOptions(options);
        }
    }, [polyline, options]);

    return null;
};

export default RoutePolyline